import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AdminLoginDto,
  BackendErrorEntity,
  LoginEntity,
  OtpDto,
  SendOtpBodyDto,
  UserEntity,
  UserSignupBodyDto,
  VerifyOtpBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiAdminLogin = (
    adminLoginDto: MaybeRef<AdminLoginDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      adminLoginDto = unref(adminLoginDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/admin/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminLoginDto
    },
      options);
    }
  


export const getApiAdminLoginMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<AdminLoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<AdminLoginDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminLogin>>, {data: BodyType<AdminLoginDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminLoginMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminLogin>>>
    export type ApiAdminLoginMutationBody = BodyType<AdminLoginDto>
    export type ApiAdminLoginMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminLogin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminLogin>>, TError,{data: BodyType<AdminLoginDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminLogin>>,
        TError,
        {data: BodyType<AdminLoginDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUserSignUp = (
    userSignupBodyDto: MaybeRef<UserSignupBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      userSignupBodyDto = unref(userSignupBodyDto);
      
      return fetchApiInstance<UserEntity>(
      {url: `/auth/userSignup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userSignupBodyDto
    },
      options);
    }
  


export const getApiUserSignUpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUserSignUp>>, {data: BodyType<UserSignupBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUserSignUp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUserSignUpMutationResult = NonNullable<Awaited<ReturnType<typeof apiUserSignUp>>>
    export type ApiUserSignUpMutationBody = BodyType<UserSignupBodyDto>
    export type ApiUserSignUpMutationError = ErrorType<BackendErrorEntity>

    export const useApiUserSignUp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUserSignUp>>, TError,{data: BodyType<UserSignupBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUserSignUp>>,
        TError,
        {data: BodyType<UserSignupBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUserSignUpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAuthOtpLogin = (
    otpDto: MaybeRef<OtpDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      otpDto = unref(otpDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/admin/otp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otpDto
    },
      options);
    }
  


export const getApiAuthOtpLoginMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAuthOtpLogin>>, {data: BodyType<OtpDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAuthOtpLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAuthOtpLoginMutationResult = NonNullable<Awaited<ReturnType<typeof apiAuthOtpLogin>>>
    export type ApiAuthOtpLoginMutationBody = BodyType<OtpDto>
    export type ApiAuthOtpLoginMutationError = ErrorType<BackendErrorEntity>

    export const useApiAuthOtpLogin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAuthOtpLogin>>, TError,{data: BodyType<OtpDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAuthOtpLogin>>,
        TError,
        {data: BodyType<OtpDto>},
        TContext
      > => {

      const mutationOptions = getApiAuthOtpLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminSendUserOtp = (
    sendOtpBodyDto: MaybeRef<SendOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendOtpBodyDto = unref(sendOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/auth/admin/sendOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendOtpBodyDto
    },
      options);
    }
  


export const getApiAdminSendUserOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, {data: BodyType<SendOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminSendUserOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminSendUserOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminSendUserOtp>>>
    export type ApiAdminSendUserOtpMutationBody = BodyType<SendOtpBodyDto>
    export type ApiAdminSendUserOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminSendUserOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminSendUserOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminSendUserOtp>>,
        TError,
        {data: BodyType<SendOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminSendUserOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiVerifySignupOtp = (
    verifyOtpBodyDto: MaybeRef<VerifyOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      verifyOtpBodyDto = unref(verifyOtpBodyDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/signup/verifyOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpBodyDto
    },
      options);
    }
  


export const getApiVerifySignupOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifySignupOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiVerifySignupOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiVerifySignupOtp>>, {data: BodyType<VerifyOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiVerifySignupOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiVerifySignupOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiVerifySignupOtp>>>
    export type ApiVerifySignupOtpMutationBody = BodyType<VerifyOtpBodyDto>
    export type ApiVerifySignupOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiVerifySignupOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifySignupOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiVerifySignupOtp>>,
        TError,
        {data: BodyType<VerifyOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiVerifySignupOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiSendSignupOtp = (
    sendOtpBodyDto: MaybeRef<SendOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendOtpBodyDto = unref(sendOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/auth/signup/sendOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendOtpBodyDto
    },
      options);
    }
  


export const getApiSendSignupOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendSignupOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSendSignupOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSendSignupOtp>>, {data: BodyType<SendOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSendSignupOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSendSignupOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiSendSignupOtp>>>
    export type ApiSendSignupOtpMutationBody = BodyType<SendOtpBodyDto>
    export type ApiSendSignupOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiSendSignupOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendSignupOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSendSignupOtp>>,
        TError,
        {data: BodyType<SendOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSendSignupOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiSendLoginOtp = (
    sendOtpBodyDto: MaybeRef<SendOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendOtpBodyDto = unref(sendOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/auth/login/sendOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendOtpBodyDto
    },
      options);
    }
  


export const getApiSendLoginOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendLoginOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSendLoginOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSendLoginOtp>>, {data: BodyType<SendOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSendLoginOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSendLoginOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiSendLoginOtp>>>
    export type ApiSendLoginOtpMutationBody = BodyType<SendOtpBodyDto>
    export type ApiSendLoginOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiSendLoginOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSendLoginOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSendLoginOtp>>,
        TError,
        {data: BodyType<SendOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSendLoginOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiVerifyLoginOtp = (
    verifyOtpBodyDto: MaybeRef<VerifyOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      verifyOtpBodyDto = unref(verifyOtpBodyDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/auth/login/verifyOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpBodyDto
    },
      options);
    }
  


export const getApiVerifyLoginOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyLoginOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiVerifyLoginOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiVerifyLoginOtp>>, {data: BodyType<VerifyOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiVerifyLoginOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiVerifyLoginOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiVerifyLoginOtp>>>
    export type ApiVerifyLoginOtpMutationBody = BodyType<VerifyOtpBodyDto>
    export type ApiVerifyLoginOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiVerifyLoginOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyLoginOtp>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiVerifyLoginOtp>>,
        TError,
        {data: BodyType<VerifyOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiVerifyLoginOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    